module.exports = __webpack_public_path__ + "fonts/AkagiPro-Light.d9114d22.ttf";